import React from 'react'
import { createComponent } from 'react-fela'

const button = props => ({
  padding: props.big ? '12px 25px' : '10px 20px',
  minWidth: 200,
  textAlign: 'center',
  border: '2px solid ' + props.color,
  borderRadius: 5,
  color: props.color,
  fontWeight: 700,
  alignSelf: 'center',
  cursor: 'pointer',
  userSelect: 'none',
  transition: '300ms all ease-in-out',
  ':hover': {
    borderColor: props.hoverColor,
    color: props.hoverColor,
    ':active': {
      backgroundColor: props.activeColor,
      borderColor: props.activeColor,
      color: props.activeFontColor
    }
  }
})

const Button = ({ onClick, className, text }) => (
  <div onClick={onClick} className={className}>
    {text}
  </div>
)

export default createComponent(button, Button, [ 'onClick', 'text' ])



// WEBPACK FOOTER //
// ../styleguide/Button.js